import LoginPage from "./Pages/LoginPage";

require('../bootstrap');

import {createApp, h} from 'vue'

import routes from "./router/routes-login";
import './assets/sass/app.scss'
import {asset} from "@codinglabs/laravel-asset";

const mixin = {
    methods: {
        asset: asset,
        castTimestamps(obj) {
            // let date = new Date(obj.created_at);
            // obj.created_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
            //
            // date = new Date(obj.updated_at);
            // obj.updated_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
        }
    }
}

const el = document.getElementById('app');
const app = createApp(
    {
        render: () => h(LoginPage),
    })
    .use(routes)

app.mount(el)
